export default __webpack_public_path__ + "7dc68a1aaa76f802b5c3ebc1b8271435.png";